import React from 'react';

import { displayText, formatPhone } from './formatters';
import ReadOnlyField from './ReadOnlyField';
import SectionCard from './SectionCard';

export default function AccountantCard({ name, phone, email }) {
  return (
    <SectionCard title="Dados contador">
      <ReadOnlyField label="Nome contato" value={displayText(name)} />
      <ReadOnlyField label="Telefone" value={formatPhone(phone)} />
      <ReadOnlyField label="E-mail" value={displayText(email)} />
    </SectionCard>
  );
}
